import React from 'react';
import PropTypes from 'prop-types';
import MuiDialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import ActionButton from 'components/Common/ActionButton';
import Styles from './index.module.css';

export default function Dialog({
  title,
  content,
  hideCancel,
  onSubmit,
  onCancel,
  open,
  onClose,
  submitText,
}) {
  return (
    <MuiDialog open={open} onClose={onClose} className={Styles.mainContainer}>
      <DialogTitle className={Styles.dialogTitle}>{title}</DialogTitle>
      <DialogContent className={Styles.dialogContent}>{content}</DialogContent>
      <DialogActions>
        {!hideCancel && (
          <ActionButton autoFocus onClick={onCancel} style={{ backgroundColor: '#9A9A9A', marginRight: 12, color: '#FFFFFF' }} className={Styles.dialogButton}>
            取消
          </ActionButton>
        )}
        <ActionButton style={{ color: '#FFFFFF' }} onClick={onSubmit} className={Styles.dialogButton}>
          {submitText}
        </ActionButton>
      </DialogActions>
    </MuiDialog>
  );
}

Dialog.propTypes = {
  title: PropTypes.string,
  submitText: PropTypes.string,
  content: PropTypes.node,
  hideCancel: PropTypes.bool,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
};

Dialog.defaultProps = {
  title: '',
  submitText: '確認',
  content: null,
  hideCancel: true,
  onSubmit: () => {},
  onCancel: () => {},
  onClose: () => {},
  open: false,
};
